import routeConfig from './config/routerConfig'

export default [
  {
    path: routeConfig.shopDetail,
    name: 'shopDetail',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'shop' */
        '@/pages-JP/shopDetail/index'
        ))
    }
  },
  {
    path: routeConfig.bizoppDetail,
    name: 'bizoppDetail',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'shop' */
        '@/pages-JP/shopDetail/index'
        ))
    }
  },
  {
    path: routeConfig.shopDetailMapView,
    name: 'mapView',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'mapvied' */
        '@/pages-JP/shopDetail/pages/mapView'
        ))
    }
  },
  {
    path: routeConfig.shopDetailBaseDetail,
    name: 'shopBaseDetail',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'shopBaseDetail' */
        '@/pages-JP/shopDetail/pages/shopBaseDetail'
        ))
    }
  },
  {
    path: routeConfig.shopDetailList + ':page',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'list' */
        '@/pages-JP/shopDetail/pages/list'
        ))
    }
  },
  {
    path: routeConfig.shopDetailGallery,
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'gallery' */
        '@/pages-JP/shopDetail/pages/gallery'
        ))
    }
  },
  {
    path: routeConfig.shopDetailListDetail + ':page',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'listDetailPage' */
        '@/pages-JP/shopDetail/pages/listDetailPage'
        ))
    }
  },
  {
    path: routeConfig.salesData,
    name: 'salesData',
    async component (resolve) {
      resolve(await import(
        /* webpackChunkName: 'shop' */
        '@/pages-JP/shopDetail/pages/saleData'
        ))
    }
  },

]
